<template lang="pug">
  section.navigation
    .logo-wrapper
      Logo
    .menu-ellipsis
      nav
        a(href="http://mtonline.latercera.com/") Inicio
        a(href="http://mtonline.latercera.com/categorias/test-drive/") Test Drive
        a(href="http://mtonline.latercera.com/categorias/lanzamientos/") Lanzamientos
        a(href="http://mtonline.latercera.com/categorias/salones/") Salones
        a(href="http://mtonline.latercera.com/categorias/videos/") Videos
        a(href="http://mtonline.latercera.com/categorias/mtmag/") MTMag
</template>

<script>
  import Logo from '@/components/Logo'
  export default  {
    name: 'navigation',
    components: {
      Logo
    }
}
</script>

<style scoped lang="postcss">
  .navigation{
    display: grid;
    grid-template-columns: 100px auto;
    align-items: center;
    min-height: 50px;
    @media screen and (max-width: 900px){
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .menu-ellipsis{
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    display: table-cell;
    padding-left: 2rem;
    @media screen and (max-width: 900px){
      display: none;
    }
    &:after{
      content: "";
      background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 15px;
    }
  }
  nav{
    display: inline;
    align-items: center;
    justify-content: center;
    a{
      color: #1b3043;
      font-size: 13.5px;
      line-height: 19.2857px;
      text-decoration: none;
      text-transform: uppercase;
      transition: all .3s ease;
      font-family: 'Open Sans', sans-serif;
      padding-left: 0.8rem;
      padding-right: 0.8rem;
      -webkit-font-smoothing: antialiased;
      &:hover{
        color: #b10925;
      }
    }
  }

  .logo-wrapper{
    max-width: 100px;
  }
</style>
